import { BIC_CODES } from "./constants";

const BANK_ID_LENGTH = 4;

export const getBic = (iban: string) => BIC_CODES[iban.substr(BANK_ID_LENGTH, BANK_ID_LENGTH)];
